import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const AddressFumei = props => {
  return <Dropdown.Static kubunKey='address_fumei' {...props} />
}
